export interface ISwapQualityIssueCounts {
    pendingResponse: number,
    issueReportedIncomplete: number,
    issueReportedCompleted: number,
    noIssueReported: number,
    total: number
}